<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12 bg-dark-blue">
          <img src="/img/arrow-left-white.svg" class="mt-4" height="30" @click="$router.back()" />
          <h5 class="text-align-right white bold mt-3 mb-5">Qual atividade do projeto você está mais ansioso para participar?</h5>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12 p-4">
          <div>
            <!-- Grupo de Checkbox -->
            <div class="checkbox-group">
              <div class="checkbox-option" v-for="option in checkboxOptions" :key="option.value"
                @click="toggleCheckbox(option.value)">
                <input type="checkbox" :id="option.value" v-model="selectedCheckboxes" :value="option.value" hidden>
                <div class="custom-checkbox" :class="{ active: selectedCheckboxes.includes(option.value) }"></div>
                <span>{{ option.label }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <button class="continue-btn" :disabled="loading" @click.prevent="handle">
            <span>CONTINUAR </span>
          </button>
        </div>
      </div>
      <vue-bottom-sheet-vue2 ref="warning" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Não foi possivel enviar as informações</h5>
        </div>
      </vue-bottom-sheet-vue2>
      <vue-bottom-sheet-vue2 ref="required" drag-color="rgba(255, 255, 255, 0.5)">
        <div class="text-center pb-5">
          <h5 class="text-info">Escolha uma das opções</h5>
        </div>
      </vue-bottom-sheet-vue2>
    </div>
    <Loading v-if="loading" />
    <ModalSucesso :show="modalSucesso" @hide="modalSucesso = false" />
  </div>
</template>

<script>
import api from "../axiosConfig"; 
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";

export default {
  components: {
    VueBottomSheetVue2,
    Loading: () => import("./Loading.vue"),
    ModalSucesso: () => import("./ModalSucesso.vue"),
  },
  data() {
    return {
      data: undefined,
      loading: false,
      selectedCheckboxes: [],
      idUsuario: undefined,
      modalSucesso: false,
      checkboxOptions: [
        { label: "Atividade física funcional", value: "Atividade física funcional" },
        { label: "Aulas de nutrição e alimentação saudável", value: "Aulas de nutrição e alimentação saudável" },
        { label: "Uso do chat e inclusão digital da comunidade do projeto", value: "Uso do chat e inclusão digital da comunidade do projeto" },
        { label: "Participar do evento", value: "Participar do evento" },
        { label: "Todas as opções", value: "Todas as opções" },
      ]
    };
  },
  created() {
    const idUsuario = window.sessionStorage.getItem("idUsuario");

    if (idUsuario === null || idUsuario === undefined || idUsuario === "undefined" || idUsuario === "") {
      this.$router.push("/login");
    } else {
      const parsedIdCliente = JSON.parse(idUsuario);
      this.idUsuario = parsedIdCliente;
    }
  },
  methods: {

    toggleCheckbox(value) {
      const index = this.selectedCheckboxes.indexOf(value);
      if (index === -1) {
        this.selectedCheckboxes.push(value);
      } else {
        this.selectedCheckboxes.splice(index, 1);
      }
    },

    async handle() {

      await this.save();
    },

    async save() {
      try {
        this.loading = true;

        let descricao = "";

        if (this.selectedCheckboxes.length > 0) {
          descricao += this.selectedCheckboxes.join(", ");
        } else {
          this.$refs.required.open();
          this.loading = false;
          return;
        }

        var payload = {
          usuarioId: this.idUsuario,
          perguntaId: "03877a99-ee24-476e-8d10-87116051b0f8",
          descricao: descricao,
        };

        await api.post('/respostas', payload);

        this.loading = false;

        this.modalSucesso = true;
      } catch (error) {
        this.$refs.warning.open();
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.radio-group,
.checkbox-group {
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 20px;
  align-items: flex-start;
}

.checkbox-group {
  flex-direction: column;
  gap: 10px;
}

.radio-option,
.checkbox-option {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 18px;
  font-weight: bold;
  color: #0D4275;
  cursor: pointer;
}

.custom-radio,
.custom-checkbox {
  width: 20px;
  height: 20px;
  border: 2px solid #2699FB;
  display: inline-block;
  position: relative;
}

.custom-radio {
  border-radius: 50%;
}

.radio-option input:checked+.custom-radio {
  background-color: #2699FB;
}

.radio-option input:checked+.custom-radio::after {
  content: "";
  width: 8px;
  height: 8px;
  background: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
}

.checkbox-option input:checked+.custom-checkbox {
  background-color: #2699FB;
}

.checkbox-option input:checked+.custom-checkbox::after {
  content: "";
  width: 10px;
  height: 5px;
  border-left: 2px solid white;
  border-bottom: 2px solid white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -60%) rotate(-45deg);
}
</style>